export default function navPanels() {
	const panels = document.querySelectorAll('[data-nav-panel]')

	if (!panels) return

	Object.keys(panels).forEach(function (panel) {
		bindNavPanel(panels[panel])
	})
}

function isMobile() {
	return window.matchMedia('(max-width: 1000px').matches
}

function bindNavPanel(panel) {
	const trigger = panel.querySelector('[data-nav-panel-trigger]')
	const content = panel.querySelector('[data-nav-panel-content]')
	const submenu = panel.closest('.sub-menu')

	if (!trigger || !content) return

	trigger.addEventListener('mouseenter', function () {
		if (isMobile()) return true

		showNavPanelContent(content, submenu)
	})

	trigger.addEventListener('click', function (e) {
		e.stopPropagation()
		showNavPanelContent(content, submenu, trigger)
	})
}

function showNavPanelContent(content, submenu, trigger) {
	if (isMobile() && content.classList.contains('is-expanded-mobile')) {
		hideNavPanelContent(submenu)
	} else {
		hideNavPanelContent(submenu)

		const lastActivePanel = content.closest('[data-nav-panel]')
		if (lastActivePanel) {
			lastActivePanel.classList.add('is-expanded')
		}

		content.classList.add('is-expanded')

		if (trigger) {
			const triggerButton = trigger.querySelector('button')
			if (triggerButton) {
				triggerButton.setAttribute('aria-expanded', true)
			}
		}
	}
}

function hideNavPanelContent(submenu) {
	const lastActive = submenu.querySelector('[data-nav-panel-content].is-expanded')
	const lastActivePanel = lastActive ? lastActive.closest('[data-nav-panel]') : null
	const lastActiveTrigger = submenu.parentNode.querySelector('[data-nav-panel-trigger] button')

	if (lastActivePanel) {
		lastActivePanel.classList.remove('is-expanded')
	}
	if (lastActive) {
		lastActive.classList.remove('is-expanded')
	}

	if (lastActiveTrigger) {
		lastActiveTrigger.setAttribute('aria-expanded', false)
	}
}
